import { render, staticRenderFns } from "./CourseResourceEdit.vue?vue&type=template&id=00dda40b&scoped=true&"
import script from "./CourseResourceEdit.vue?vue&type=script&lang=js&"
export * from "./CourseResourceEdit.vue?vue&type=script&lang=js&"
import style0 from "./CourseResourceEdit.vue?vue&type=style&index=0&id=00dda40b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00dda40b",
  null
  
)

export default component.exports